import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@cider/ui/fonts.css';
import '@cider/ui/tokens.css';
import '@cider/ui/components.css';
import '@cider/ui/shell.css';
import '@cider/ui/page.css';
import '@cider/ui/sheet.css';
import '@cider/ui/wall.css';
import './app.css';
import './views/chairs/app.css';
import './print/print.css';
import './views/login/login.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('no #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
      console.error('service worker failed to register', err);
    });
  });
}
